import {
  CountRequest,
  CountResponse,
  EntityAttribute,
  ListEventsRequest,
} from "shared/api/api";
import { DEFAULT_ATTRIBUTES_SWR_CONFIG } from "shared/api/constants";
import { useAPI, usePaginatedAPI } from "shared/api/hooks";
import { CountRequestWithVehiclesFilter } from "shared/api/vehicles/api";

import {
  listSignalEventOccurrencesAttributesRequestURI,
  listSignalEventOccurrencesVINAggregateCountRequestURI,
  ListSignalEventOccurrencesVINAggregateRequest,
  listSignalEventOccurrencesVINAggregateRequestURI,
  ListSignalEventOccurrencesVINTimelineRequest,
  listSignalEventOccurrencesVINTimelineRequestURI,
  listSignalEventsOccurrencesCountRequestURI,
  listSignalEventsOccurrencesRequestURI,
  SignalEventOccurrencesAggregateBucket,
  SignalEventOccurrencesV2TimelineBucket,
  SignalEventsOccurrence,
} from "./api";

export const useListSignalEventOccurrencesVINTimeline = (
  args: ListSignalEventOccurrencesVINTimelineRequest
) =>
  usePaginatedAPI<typeof args, SignalEventOccurrencesV2TimelineBucket[]>(
    listSignalEventOccurrencesVINTimelineRequestURI,
    args
  );

export const useListSignalEventOccurrencesVINAggregate = (
  args: ListSignalEventOccurrencesVINAggregateRequest
) =>
  usePaginatedAPI<typeof args, SignalEventOccurrencesAggregateBucket[]>(
    listSignalEventOccurrencesVINAggregateRequestURI,
    args
  );

export const useListSignalEventOccurrencesVINAggregateCount = (
  args: CountRequest
) =>
  usePaginatedAPI<typeof args, CountResponse>(
    listSignalEventOccurrencesVINAggregateCountRequestURI,
    args
  );

export const useListSignalEventsOccurrences = (args: ListEventsRequest) =>
  usePaginatedAPI<typeof args, SignalEventsOccurrence[]>(
    listSignalEventsOccurrencesRequestURI,
    args
  );

export const useListSignalEventsOccurrencesCount = (
  args: CountRequestWithVehiclesFilter
) =>
  usePaginatedAPI<typeof args, CountResponse>(
    listSignalEventsOccurrencesCountRequestURI,
    args
  );

export const useSignalEventOccurrencesAttributes = () =>
  useAPI<null, EntityAttribute[]>(
    listSignalEventOccurrencesAttributesRequestURI,
    null,
    DEFAULT_ATTRIBUTES_SWR_CONFIG
  );
